import { notification as antNotification } from 'antd';

export default function notification(params: any) {
    antNotification.open(params);
}